import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Back is the router's history: the screen this one was opened from, as the
 * phone's own back gesture goes. A screen opened straight from a link or a
 * push has nothing behind it, so it goes to `fallback` (its list) instead of
 * leaving the app.
 */
export function useBack(fallback: string) {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (location.key !== 'default') navigate(-1);
    else navigate(fallback, { replace: true });
  }, [fallback, location.key, navigate]);
}
